export default __webpack_public_path__ + "static/smi-meshery-ed50770609de7c1304ef4582a13c66a2.webp";